import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "embed-home" }

import { ref, onMounted } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import api from '../../../api/v2/api'
import { userState } from '../../../client/stores/user'
import { EMBED_ROUTER_NAME } from '../../../embed/router'
import { headerState } from '../../../client/stores/header'

const EMBED_KEY = 'edbase-embed-token'


export default /*@__PURE__*/_defineComponent({
  __name: 'Home',
  setup(__props) {

const route = useRoute()
const router = useRouter()

const targetId = ref<string | null>(null)
const embedToken = ref<string | null>(getEmbedToken())
const exam = ref<any>(null)

function getEmbedToken(): string | null {
  try {
    return localStorage.getItem(EMBED_KEY)
  } catch (error) {
    console.error("localStorage access deny")
    console.error(error)
    return null
  }
}

function setEmbedToken(token: string) {
  try {
    localStorage.setItem(EMBED_KEY, token)
  } catch (error) {
    console.error("localStorage access deny")
    console.error(error)
  }
}

async function getToken() {
  embedToken.value = await api.embed.create({
    targetId: targetId.value,
    type: "EXAM",
    embedToken: embedToken.value ?? undefined
  })
  
  // Set Embed Token into storage
  if (embedToken.value) {
    setEmbedToken(embedToken.value)
  }
  
  // Set embedToken in global
  ;(window as any).embedToken = embedToken.value
}

async function getUser() {
  await userState.getUser()
  router.push({
    name: EMBED_ROUTER_NAME.EXAM_SHOW,
    params: {
      examId: targetId.value ?? ''
    }
  })

  headerState.getSchoolSetting()
}

onMounted(async () => {
  targetId.value = route.params.targetId as string
  if (targetId.value) {
    if (window.location.href.includes('embed/exam')) {  
      try {
        exam.value = await api.exam.showForTest(targetId.value, {})
      } catch (error: any) {
        if (error.messages === 'Need to join exam') {
          getToken()
        }
      }
    }

    if (embedToken.value === null) {
      getToken()
    }
    getUser()
  }
})

return (_ctx: any,_cache: any) => {
  const _component_v_btn = _resolveComponent("v-btn")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[3] || (_cache[3] = _createElementVNode("div", null, " Edbaseシステムエンベッドへようこそ ", -1 /* CACHED */)),
    _createVNode(_component_v_btn, {
      class: "m-2",
      color: "success",
      disabled: embedToken.value === null,
      onClick: _cache[0] || (_cache[0] = ($event: any) => (embedToken.value ? undefined : getToken()))
    }, {
      loader: _withCtx(() => [...(_cache[1] || (_cache[1] = [
        _createElementVNode("span", null, "Loading...", -1 /* CACHED */)
      ]))]),
      default: _withCtx(() => [
        _cache[2] || (_cache[2] = _createTextVNode(" テスト参加 ", -1 /* CACHED */))
      ]),
      _: 1 /* STABLE */
    }, 8 /* PROPS */, ["disabled"])
  ]))
}
}

})